window.pages["productlinerecipes.index"] = {
    page: document.body.getAttribute('page'),

    init: function () {
        window.components.accordionItem.init();
        $(function () {
            const pathname = $(location).attr('pathname'); 
            if (pathname == '/receitas-cereal-infantil') {
                $('.recipes-header').show();
                $('.product-header').hide();
            } 
        });
    }
};
